import { API_URL } from '@constants'
import axiosReadInstance from '../../request/axiosReadInstance'
import ReactMarkdown from 'react-markdown'
import { cmsRehypePlugins } from '../../security/cmsMarkdown'
import { useEffect, useState } from 'react'
import { replaceImageExtension } from '@utils'
import { Image } from '@types'

interface IExpertiseIntro {
    content: string
    title: string
}

export const ExpertiseIntro = () => {
    const [expertiseIntro, setExpertiseIntro] = useState<IExpertiseIntro>()
    const [image, setImage] = useState<Image>()

    const markdown = `${expertiseIntro?.content}`

    const fetchData = async () => {
        await axiosReadInstance
            .get(`${API_URL}/api/expertise-intro?populate=deep`)
            .then((response) => {
                setExpertiseIntro(response.data.data.attributes)
                setImage(response.data.data.attributes.ltBackground.data)
            })
    }
    useEffect(() => {
        fetchData()
    }, [])

    return (
        <>
            <section className="bg-white mt-2 lg:mt-[175px]  ">
                <div className="py-8 lg:py-16 ">
                    <div className="z-20 relative md:px-[8rem]">
                        <h1 className="mb-8 mt-6 text-2xl md:text-4xl lg:text-5xl font-semibold text-left text-gray-500 mx-auto max-w-full  ">
                            {expertiseIntro?.title}
                        </h1>
                        <ReactMarkdown
                            className="prose text-justify"
                            rehypePlugins={cmsRehypePlugins}
                        >
                            {markdown || ''}
                        </ReactMarkdown>
                    </div>
                    <div className="z-10 min-h-auto max-h-[450px] overflow-hidden pl-[5rem] relative float-left sm:min-h-[200px] md:min-h-[250px] mt-[-24rem]">
                        <img
                            src={`${replaceImageExtension(
                                image?.attributes.url
                            )}`}
                            alt={image?.attributes.alternativeText}
                        />
                    </div>
                </div>
            </section>
        </>
    )
}
